import { AtlassianLogo } from '@atlaskit/logo';
import { colors, gridSize } from '@atlaskit/theme';
import { inject } from 'mobx-react';
import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import styled from 'styled-components';

import Store from '../../store';
import UserStore from '../../store/userStore';
import { getDomainFromEmail } from '../../util/email';

export const Container = styled.header`
  margin: ${gridSize() * 5}px 0 ${gridSize() * 3}px;
  color: ${colors.N300};
  text-align: center;
  font-size: 14px;
`;

export const Title = styled.h1`
  color: inherit;
  font-size: 16px;
  font-weight: 600;
  line-height: 20px;
`;

export const Description = styled.p`
  margin: 0;
  line-height: 20px;
`;

interface Props {
  userStore: UserStore;
}

class InterimHeader extends React.Component<Props> {
  render() {
    const collaborationDomain = getDomainFromEmail(this.props.userStore.email) || '';
    return (
      <Container>
        <AtlassianLogo
          size="large"
          iconColor={colors.B200}
          textColor={colors.B400}
          iconGradientStart={colors.B400}
          iconGradientStop={colors.B200}
        />
        <Title>
          <FormattedMessage {...messages.title} />
        </Title>
        <Description>
          <FormattedMessage
            {...messages.collaboratorsOnDomain}
            values={{
              domain: <b>{collaborationDomain}</b>,
            }}
          />
        </Description>
      </Container>
    );
  }
}

export const messages = defineMessages({
  collaboratorsOnDomain: {
    defaultMessage: 'Join people from {domain} who are already working on these products.',
    description:
      'Current collaborators description, displayed before the invitation to collaboration on the interim home page',
    id: 'uchi.interimHome.collaboratorsOnDomain',
  },
  title: {
    defaultMessage: 'Join your team',
    description: 'The main header on the interim home page',
    id: 'uchi.interimHome.title',
  },
});

export default inject(({ userStore }: Store) => ({
  userStore,
}))(InterimHeader);
